// Request will be proxied via /api/be/[...apiGateway].ts
const baseUrl = "/api/be";

export const BackendApiUrl = {
  test: baseUrl + "/api/test",

  //Auth
  login: baseUrl + "/api/Authentication/login", 
  register: baseUrl + "/api/Authentication/register", 
  forgotPassword: baseUrl + "/api/Authentication/forgot-password", 
  checkEmail: baseUrl + "/api/Authentication/check-email", 
  resendConfirmEmail: baseUrl + "/api/Authentication/resend-confirmation-email", 

  //Company Introduction
  getCompanyIntroduction: baseUrl + "/api/CompanyIntro/company-intro", 

  //Dasboard
  getCompanyProgramsList: baseUrl + "/api/Dashboard/get-company-programs", 

  //User
  changePassword: baseUrl + "/api/User/update-password",
  createUserWithGoogle: "/api/User/google",

  //Vacancies
  getVacanciesList: baseUrl + "/api/Vacancies/get-vacancies-list", 
  getVacancyDetail: baseUrl + "/api/Vacancies/vacancy-detail", 

  //Dropdown
  getBusinessUnitDropdownList: baseUrl + "/api/Dropdown/get-business-unit-list", 
  getCategoriesDropdownList: baseUrl + "/api/Dropdown/get-category-list", 
  getYearExperienceDropdownList: baseUrl + "/api/Dropdown/get-year-experience-list",

  //Application History List
  getApplicationHistoryList: baseUrl + "/api/v1/application-history", 
  addApplicationHistory: baseUrl + "/api/v1/application-history/add-application-history", 

  //profileDetail
  getUserProfile: baseUrl + "/api/Profile/get-profile-detail",
  addSkill: baseUrl + "/api/Profile/add-skill",
  deleteAllSkill: baseUrl + "/api/Profile/delete-all",
  addEducation: baseUrl + "/api/Profile/add-education",
  deleteEducation: baseUrl + "/api/Profile/delete-education",
  editEducation: baseUrl + "/api/Profile/update-education",
  editPersonalData: baseUrl + "/api/Profile/update-personal-data",
  getAllSkill : baseUrl + "/api/Profile/get-all-skill",

  googleLogin: baseUrl + "/api/Authentication/login/google",
};
